import { render, staticRenderFns } from "./CarousselImage.vue?vue&type=template&id=e9a4e3d2&scoped=true&"
import script from "./CarousselImage.vue?vue&type=script&lang=js&"
export * from "./CarousselImage.vue?vue&type=script&lang=js&"
import style0 from "./CarousselImage.vue?vue&type=style&index=0&id=e9a4e3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a4e3d2",
  null
  
)

export default component.exports